import { createI18n } from "vue-i18n";
import en from "@/locales/en.json";
import it from "@/locales/it.json";

const messages = {
    en: en,
    it: it,
};

const savedLocale = localStorage.getItem("locale") || "en";

const i18n = createI18n({
    locale: savedLocale,
    fallbackLocale: "en",
    messages,
});

export function setLocale(locale) {
    i18n.global.locale = locale;
    localStorage.setItem("locale", locale);
}

export default i18n;
